import React, { Component } from 'react';
import { Link, withRouter } from "react-router-dom";

import ContactForm from './ContactForm';

class ContactFormWrapper extends Component {
	render() {
		console.log(this)
		return (
			<div className={'card content-container mt-4 manual-init'}>
				 <div className="page-content card-body">
						<h2>Hafa samband</h2>
						<p>Hér getur þú haft samband við ritstjóra orðasafnsins <Link to={'/leit//ordabok/'+this.props.match.params.ordabok}>{window.ordabankiData && window.ordabankiData.dictionaries ? window.ordabankiData.dictionaries[this.props.match.params.ordabok] : this.props.match.params.ordabok}</Link></p>
						<br/>
						<ContactForm formId={this.props.match.params.ordabok} />
				</div>
			</div>
		);
	}
}

export default ContactFormWrapper;



// WEBPACK FOOTER //
// ./src/components/ContactFormWrapper.js